import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type TPageLayoutProps = {
  children: ReactNode;
  className?: string;
  containerClassName?: string;
};

export function PageLayout({ children, className, containerClassName }: TPageLayoutProps) {
  return (
    <div className={cn("h-full min-h-0 overflow-auto p-4", className)}>
      <main className={cn("mx-auto flex h-full min-h-0 w-full max-w-7xl flex-col gap-4", containerClassName)}>
        {children}
      </main>
    </div>
  );
}
